import './missing-services.js';
import './contributions.js';
export { default as Severity } from 'monaco-editor/esm/vs/base/common/severity.js';
export { StorageScope, StorageTarget } from './vscode/src/vs/platform/storage/common/storage.js';
import { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
export { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
import { mixin } from 'monaco-editor/esm/vs/base/common/objects.js';
import { IInstantiationService } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
export { IInstantiationService } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { IProductService } from 'monaco-editor/esm/vs/platform/product/common/productService.js';
export { IProductService } from 'monaco-editor/esm/vs/platform/product/common/productService.js';
import { DisposableStore } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { initialize as initialize$1 } from './workbench.js';
import { checkServicesNotInitialized, startup, waitServicesReady, checkServicesReady, serviceInitializedBarrier, serviceInitializedEmitter } from './lifecycle.js';
import getServiceOverride$4 from '@codingame/monaco-vscode-quickaccess-service-override';
import getServiceOverride$1$2 from '@codingame/monaco-vscode-files-service-override';
import getServiceOverride$2 from '@codingame/monaco-vscode-extensions-service-override';
import getServiceOverride$1$1 from '@codingame/monaco-vscode-environment-service-override';
import getServiceOverride$1 from '@codingame/monaco-vscode-layout-service-override';
import getServiceOverride$5 from '@codingame/monaco-vscode-host-service-override';
import getServiceOverride$6 from '@codingame/monaco-vscode-base-service-override';
export { SyncDescriptor } from 'monaco-editor/esm/vs/platform/instantiation/common/descriptors.js';
export { ICommandService } from 'monaco-editor/esm/vs/platform/commands/common/commands.js';
export { INotificationService, NeverShowAgainScope, NoOpNotification, NoOpProgress, NotificationPriority, NotificationsFilter } from 'monaco-editor/esm/vs/platform/notification/common/notification.js';
export { IBulkEditService } from 'monaco-editor/esm/vs/editor/browser/services/bulkEditService.js';
export { ICodeEditorService } from 'monaco-editor/esm/vs/editor/browser/services/codeEditorService.js';
export { ILanguageService } from 'monaco-editor/esm/vs/editor/common/languages/language.js';
export { ILanguageConfigurationService } from 'monaco-editor/esm/vs/editor/common/languages/languageConfigurationRegistry.js';
export { IEditorWorkerService } from 'monaco-editor/esm/vs/editor/common/services/editorWorker.js';
export { ILanguageFeaturesService } from 'monaco-editor/esm/vs/editor/common/services/languageFeatures.js';
export { IModelService } from 'monaco-editor/esm/vs/editor/common/services/model.js';
export { ITextModelService } from 'monaco-editor/esm/vs/editor/common/services/resolverService.js';
export { IClipboardService } from 'monaco-editor/esm/vs/platform/clipboard/common/clipboardService.js';
import './override/vs/platform/dialogs/common/dialogs.js';
export { IFileService } from 'monaco-editor/esm/vs/platform/files/common/files.js';
export { IMarkerService } from 'monaco-editor/esm/vs/platform/markers/common/markers.js';
export { IOpenerService } from 'monaco-editor/esm/vs/platform/opener/common/opener.js';
export { IQuickInputService } from 'monaco-editor/esm/vs/platform/quickinput/common/quickInput.js';
export { ITelemetryService } from 'monaco-editor/esm/vs/platform/telemetry/common/telemetry.js';
export { IUriIdentityService } from 'monaco-editor/esm/vs/platform/uriIdentity/common/uriIdentity.js';
export { IBreadcrumbsService } from './vscode/src/vs/workbench/browser/parts/editor/breadcrumbs.js';
export { GroupDirection, GroupLocation, GroupOrientation, GroupsArrangement, GroupsOrder, IEditorGroupsService, MergeGroupMode } from './vscode/src/vs/workbench/services/editor/common/editorGroupsService.js';
export { CloseDirection, EditorsOrder } from './vscode/src/vs/workbench/common/editor.js';
export { EditorInput } from './vscode/src/vs/workbench/common/editor/editorInput.js';
export { IEditorService } from './vscode/src/vs/workbench/services/editor/common/editorService.js';
export { IEditorResolverService } from './vscode/src/vs/workbench/services/editor/common/editorResolverService.js';
export { ITextEditorService } from './vscode/src/vs/workbench/services/textfile/common/textEditorService.js';
export { IWorkbenchEnvironmentService } from './vscode/src/vs/workbench/services/environment/common/environmentService.js';
export { IHostService } from './vscode/src/vs/workbench/services/host/browser/host.js';
export { ILanguageStatusService } from './vscode/src/vs/workbench/services/languageStatus/common/languageStatusService.js';
export { IPaneCompositePartService } from './vscode/src/vs/workbench/services/panecomposite/browser/panecomposite.js';
export { IPathService } from './vscode/src/vs/workbench/services/path/common/pathService.js';
export { ITextFileService } from './vscode/src/vs/workbench/services/textfile/common/textfiles.js';
export { IWorkingCopyFileService } from './vscode/src/vs/workbench/services/workingCopy/common/workingCopyFileService.js';
export { IConfigurationService } from 'monaco-editor/esm/vs/platform/configuration/common/configuration.js';
export { IContextKeyService } from 'monaco-editor/esm/vs/platform/contextkey/common/contextkey.js';
export { IThemeService } from 'monaco-editor/esm/vs/platform/theme/common/themeService.js';
export { ISnippetsService } from './vscode/src/vs/workbench/contrib/snippets/browser/snippets.js';
export { IWorkspaceContextService } from 'monaco-editor/esm/vs/platform/workspace/common/workspace.js';
export { IStorageService } from 'monaco-editor/esm/vs/platform/storage/common/storage.js';
export { IAudioCueService } from 'monaco-editor/esm/vs/platform/audioCues/browser/audioCueService.js';
export { IDebugService } from './vscode/src/vs/workbench/contrib/debug/common/debug.js';
export { ILogService, ILoggerService, LogLevel } from 'monaco-editor/esm/vs/platform/log/common/log.js';
export { IViewDescriptorService, IViewsService } from './vscode/src/vs/workbench/common/views.js';
export { ILayoutService } from 'monaco-editor/esm/vs/platform/layout/browser/layoutService.js';
export { IPreferencesService } from './vscode/src/vs/workbench/services/preferences/common/preferences.js';
export { IPreferencesSearchService } from './vscode/src/vs/workbench/contrib/preferences/common/preferences.js';
export { IKeybindingEditingService } from './vscode/src/vs/workbench/services/keybinding/common/keybindingEditing.js';
export { IOutputService } from './vscode/src/vs/workbench/services/output/common/output.js';
export { GoFilter, GoScope, IHistoryService } from './vscode/src/vs/workbench/services/history/common/history.js';
export { IRemoteAgentService } from './vscode/src/vs/workbench/services/remote/common/remoteAgentService.js';
export { IRemoteAuthorityResolverService } from './vscode/src/vs/platform/remote/common/remoteAuthorityResolver.js';
export { IRemoteSocketFactoryService } from './vscode/src/vs/platform/remote/common/remoteSocketFactoryService.js';
export { ITerminalInstanceService, ITerminalService } from './vscode/src/vs/workbench/contrib/terminal/browser/terminal.js';
export { IFilesConfigurationService } from './vscode/src/vs/workbench/services/filesConfiguration/common/filesConfigurationService.js';
export { ILabelService } from 'monaco-editor/esm/vs/platform/label/common/label.js';
export { IActivityService } from './vscode/src/vs/workbench/services/activity/common/activity.js';
export { IHoverService } from './vscode/src/vs/workbench/services/hover/browser/hover.js';
export { IExplorerService } from './vscode/src/vs/workbench/contrib/files/browser/files.js';
export { IStatusbarService } from './vscode/src/vs/workbench/services/statusbar/browser/statusbar.js';
export { ITitleService } from './vscode/src/vs/workbench/services/title/browser/titleService.js';
export { IBannerService } from './vscode/src/vs/workbench/services/banner/browser/bannerService.js';
export { IWorkspaceTrustEnablementService, IWorkspaceTrustManagementService, IWorkspaceTrustRequestService } from 'monaco-editor/esm/vs/platform/workspace/common/workspaceTrust.js';
export { IDialogService, IFileDialogService } from './vscode/src/vs/platform/dialogs/common/dialogs.js';
async function initialize(overrides, container = document.body, configuration = {}) {
    checkServicesNotInitialized();
    initialize$1(container, configuration);
    const instantiationService = StandaloneServices.initialize({
        [( IProductService.toString())]: mixin({
            version: "1.85.0",
            quality: 'oss',
            commit: "af28b32d7e553898b2a91af498b1fb666fdebe0c",
            nameShort: 'Code - OSS Dev',
            nameLong: 'Code - OSS Dev',
            applicationName: 'code-oss',
            dataFolderName: '.vscode-oss',
            urlProtocol: 'code-oss',
            reportIssueUrl: 'https://github.com/microsoft/vscode/issues/new',
            licenseName: 'MIT',
            licenseUrl: 'https://github.com/microsoft/vscode/blob/main/LICENSE.txt',
            serverApplicationName: 'code-server-oss'
        }, configuration.productConfiguration ?? {}),
        ...getServiceOverride$1(),
        ...getServiceOverride$1$1(),
        ...getServiceOverride$2(),
        ...getServiceOverride$1$2(),
        ...getServiceOverride$4(),
        ...getServiceOverride$5(),
        ...getServiceOverride$6(),
        ...overrides
    });
    await startup(instantiationService);
}
async function getService(identifier) {
    await waitServicesReady();
    return StandaloneServices.get(identifier);
}
async function createInstance(ctor, ...args) {
    await waitServicesReady();
    return StandaloneServices.get(IInstantiationService).createInstance(ctor, ...args);
}
function createInstanceSync(ctor, ...args) {
    checkServicesReady();
    return StandaloneServices.get(IInstantiationService).createInstance(ctor, ...args);
}
function withReadyServices(callback) {
    if (serviceInitializedBarrier.isOpen()) {
        return StandaloneServices.get(IInstantiationService).invokeFunction(callback);
    }
    const disposable = new DisposableStore();
    const listener = disposable.add(serviceInitializedEmitter.event(() => {
        listener.dispose();
        disposable.add(StandaloneServices.get(IInstantiationService).invokeFunction(callback));
    }));
    return disposable;
}
export { createInstance, createInstanceSync, getService, initialize, withReadyServices };
